import Checkbox from '@material-ui/core/Checkbox';
import React from 'react';
import { FormControlError } from '../../../core/shared/forms/useForm';
import { NonEmptyArray } from '../../../utils/types';

interface IProps {
  checked: boolean;
  disabled?: boolean;
  onChange: (value: boolean) => void;
  errors?: NonEmptyArray<FormControlError>;
}
export const CheckBox: React.FC<IProps> = (props) => {
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (props.onChange) {
      props.onChange(event.target.checked);
    }
  };
  return (
    <Checkbox
      color="primary"
      checked={props.checked}
      disabled={props.disabled}
      onChange={onChange}
      inputProps={
        {
          'data-error': props.errors?.length ? 'error' : '',
        } as React.InputHTMLAttributes<HTMLInputElement> & {
          'data-error': string;
        }
      }
    />
  );
};
